import { Link, LinkProps } from "react-router-dom";
import { useCallback } from "react";

const prefetchers: Record<string, () => Promise<unknown>> = {
  "/blog": () => import("@/pages/Blog"),
  "/projects": () => import("@/pages/ProjectsPage"),
  "/case-studies": () => import("@/pages/CaseStudiesPage"),
  "/contact": () => import("@/pages/ContactPage"),
  "/about": () => import("@/pages/AboutPage"),
  "/ai": () => import("@/pages/AiAgenticPage"),
  "/music": () => import("@/pages/Music"),
  "/privacy": () => import("@/pages/Privacy"),
};

const seen = new Set<string>();

export function prefetchRoute(path: string) {
  const key = Object.keys(prefetchers).find((p) => path === p || path.startsWith(p + "/"));
  if (!key || seen.has(key)) return;
  seen.add(key);
  prefetchers[key]().catch(() => seen.delete(key));
}

type PrefetchLinkProps = LinkProps & { to: string };

export function PrefetchLink({ to, onMouseEnter, onFocus, onTouchStart, ...rest }: PrefetchLinkProps) {
  const trigger = useCallback(() => prefetchRoute(to), [to]);
  return (
    <Link
      to={to}
      onMouseEnter={(e) => {
        trigger();
        onMouseEnter?.(e);
      }}
      onFocus={(e) => {
        trigger();
        onFocus?.(e);
      }}
      onTouchStart={(e) => {
        trigger();
        onTouchStart?.(e);
      }}
      {...rest}
    />
  );
}
